var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 75L96 46M150 75L96 104M150 75L204 46M150 75L204 104M150 75v-45M150 75v45",
    stroke: "#FDBA74",
    strokeWidth: 1.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 75,
    r: 9,
    fill: "#F59E0B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 46,
    r: 7,
    fill: "#FDBA74"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 104,
    r: 7,
    fill: "#FDBA74"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 46,
    r: 7,
    fill: "#F97316"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 104,
    r: 7,
    fill: "#F97316"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 30,
    r: 6,
    fill: "#FFEDD5",
    stroke: "#F97316",
    strokeWidth: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 120,
    r: 6,
    fill: "#FFEDD5",
    stroke: "#F97316",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 138h60M120 132h40",
    stroke: "#F97316",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.88eba0b7dc44c5c0dfb1a980cea2fa41.svg";
export { ForwardRef as ReactComponent };